export default {
  account: 'Project account',
  add: 'Add project',
  addDescription: 'Add project description',
  addTags: 'Add project tags',
  all: 'All projects',
  alreadyMember: 'Already project member',
  addFilesRelatedToTheProjectSuchAsDrawingsTexturesReferencesModelsEtc:
    'Add files related to the project such as drawings, textures, references, models, etc.',
  areYouSureYouWantToDeleteThisProjectYouWillNotBeAbleToUndoThisAction:
    'Are you sure you want to delete this project? You will not be able to undo this action.',
  batchOperations: 'Batch operations',
  backToProjectsList: 'Back to projects list',
  canceledPluralLowerCase: 'canceled projects',
  createYourOwnInvoiceAndAddHereAllThePartsOfYourProject:
    'Create your own invoice and add here all the parts of your project.',
  areYouSureYouWantRemoveYouFromProjectThisActionCannotBeUndone:
    'Are you sure you want remove you from project? This action cannot be undone.',
  areYouCertainAboutLeavingTheProjectPleaseBeAwareOfTheFollowingOutcomes:
    'Are you certain about leaving the project? Please be aware of the following outcomes:',
  attachDirectlyToProject: 'Attach directly to project',
  doYouAlsoWantToTurnOnNotificationsForAllTasksInThisProject:
    'Do you also want to turn on notifications for all tasks in this project?',
  doYouAlsoWantToTurnOffNotificationsForAllTasksInThisProject:
    'Do you also want to turn off notifications for all tasks in this project?',
  editDescription: 'Edit description',
  fortunatelyItsEasyToCreateOne: "Fortunately, it's easy to create one",
  group: 'Group',
  groupLowerCase: 'group',
  createGroup: 'Create group',
  groupName: 'Group name',
  moveToGroup: 'Move to group',
  moveToProject: 'Move to project',
  removeFromGroup: 'Remove from group',
  ungroup: 'Ungroup',
  changeEstimateCost: "Change project's estimate cost",
  company: 'Company projects',
  create: 'Create project',
  createNew: 'Create a new project',
  createOnly: 'Create project only',
  current: 'Current project',
  coefficient: 'K',
  description: 'Project description',
  destination: 'Destination project',
  details: 'Project Details',
  download_excel: 'Download excel document with all projects',
  download_selected_excel: 'Download excel document with selected projects',
  downloadAllTasksResults: 'Download all tasks results',
  downloadReport: 'Download report',
  edit_description: 'Edit project description',
  edit_details: 'Edit project details',
  enter_name: 'Enter the project name',
  estimate_cost: "Project's estimate cost",
  favorite: 'Favorite projects',
  id: 'Project Id',
  looksLikeYouDontHaveAnyProjects: "Looks like you don't have any projects",
  leave: 'Leave project',
  my: 'My projects',
  myResults: 'My projects results',
  results: 'Projects results',
  members: 'Project members',
  messages: 'Project Messages',
  muteProject: 'Mute project',
  muteProjectNotification: 'Mute project notification',
  name: 'Project name',
  name_a_z: 'Project name (A-Z)',
  name_z_a: 'Project name (Z-A)',
  new: 'New Project',
  no: 'No projects',
  pleaseCreateYourFirstProjectToProceed:
    'Please, create your first project to proceed',
  pleaseEvaluate: 'Please, evaluate the project',
  pleaseProvideTheProjectBriefFilesAndScopeOfWork:
    'Please provide the project brief, files, and scope of work.',
  plural: 'Projects',
  pluralGenitiveLowerCase: 'projects',
  projectName: 'Project name',
  projectTeam: 'Project team',
  projectMuted: 'Project muted',
  projectNotificationsAreTurnedOn: 'Project notifications are turned on.',
  projectNotificationsAreTurnedOff: 'Project notifications are turned off.',
  profile: 'Task Profile',
  recent: 'Recent projects',
  noVisibleProjectsFound: 'No visible projects found',
  notAllowedSubprojectsOnlyWithinSameCompanySelectedProjectsDifferentCompanies:
    'Not allowed. Subprojects can only be attached within the same company. The selected projects are owned by different companies.',
  remove_from: 'Remove from project',
  root: 'Project root',
  search: 'Search projects',
  searchByProjectName: 'Search by project name',
  searchProjectsByNameOrUser: 'Search projects by name or @user',
  select: 'Select project...',
  selectSingular: 'Select project',
  selectUser: 'Select project member',
  selected_users: 'Selected project members',
  setDueDate: 'Set project due date',
  set_cost: 'Set project cost',
  sendInvoice: 'Send invoice',
  singular: 'Project',
  singularLowerCase: 'project',
  singularAttachments: 'Project Attachments',
  start: 'Start project',
  allAttachments: 'All Project Attachments',
  singular_downcase: 'project',
  status: 'Project Status',
  tasks: 'Project tasks',
  tasksView: 'Tasks view',
  groupsView: 'Groups view',
  tags: 'Project tags',
  team: 'Project team',
  total: 'Project total',
  totalCost: 'Total cost',
  trackProjectTime: 'Track project time',
  track_time: 'Track project time',
  unallocatedFunds: 'Project unallocated funds',
  unmuteProjectNotification: 'Unmute project notification',
  update: 'Update project',
  url: 'Project URL',
  pluralLowerCase: 'projects',
  inviteSelected: 'Invite selected',
  inviteUser: 'Invite user',
  inviteToMultipleProjects: 'Invite to multiple projects',
  invitations: 'Invitations',
  view: 'View project',
  optional: 'optional',
  optionalWhenYouExpectTheProjectToBeFinished:
    '(optional) When you expect the project to be finished. It can be  changed later.',
  optionalPleaseProvideARawEstimationOnProjectBudget:
    '(optional) Please, provide a raw estimation on project budget. It can be changed later.',
  selectProductsLifestyleScenesOrMaterialsFromOur3DStockToUseInYourProject:
    'Select products, lifestyle scenes, or materials from our 3D stock to use in your project.',
  youCanCreateYourOwnInvoiceAndAddHereAllThePartsOfYourProject:
    'You can create your own invoice and add here all the parts of your project.',
  youCanAddFilesRelatedToTheProjectSuchAsDrawingsTexturesReferencesModelsEtc:
    'You can add files related to the project such as drawings, textures, references, models, etc.',
  youWillNoLongerReceiveNotificationsRelatedToThisProject:
    'You will no longer receive notifications related to this project.',
  theProjectWillBeExcludedFromYourMyProjectsList:
    'The project will be excluded from your "My Projects" list.',
  itWontBeIncludedInSearchResultsFilteredByYouAsAProjectMember:
    "It won't be included in search results filtered by you as a project member.",
  alsoMuteNotificationsForAllTasksWithinTheProject:
    'Also mute notifications for all tasks within the project',
  alsoUnmuteNotificationsForAllTasksWithinTheProject:
    'Also unmute notifications for all tasks within the project',
  refreshStatus: 'Refresh project status'
};
